/*
 * File created for running jasmine tests in node.
 * Webpack config makes require call to _gas return window._gas.
 * However webpack is not used when running tests from node. Hence,
 * check if _gas exists on window (as webpack does) and return it if it exists
 * else it returns []
 */

// check for `window` since `window` is undefined if this file is run via node
module.exports = typeof window !== 'undefined' ? (window._gas || []) : [];



//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-tracking/gas.js
// module id = ./node_modules/dibs-tracking/gas.js
// module chunks = 4